import { Text, VStack } from '@genial/components';
import { Spacing, Typography, Color } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

interface SectionContainerProps {
  title: string;
  children: React.ReactNode;
}

export const SectionContainer: React.FC<SectionContainerProps> = ({ title, children }) => {
  return (
    <VStack space={{ base: Spacing['inline.xxxs'], lg: Spacing['inline.xxs'] }}>
      <Text
        variant="semibold"
        color="neutral.black"
        fontSize={{ base: Typography['fontsize.md'], sm: Typography['fontsize.lg'] }}>
        {title}
      </Text>
      <Box h={'1px'} bg={Color['neutral.lightest']} />
      {children}
    </VStack>
  );
};
